export function isNullOrWhiteSpace(str: string | null | undefined){
    return str === null || str === undefined || str.match(/^ *$/) !== null;
}

export function stringOrEmptyPlaceholder(str: string | null | undefined): string {
    return isNullOrWhiteSpace(str) ? '-' : str!.toString();
}